export default __webpack_public_path__ + "static/media/defaultUser.1b3f7b32.svg";